import React from 'react';


export default  class Login extends React.Component {
   /* constructor(props, context) {
        super(props, context);
    }*/

    render() {
        return(
            <section>
                <div className="login_Div">
                    <div className="close_top"><a className="close">X</a></div>
                    <div className="login_top"></div>
                    <div className="big_box">
                        <input type="text" className="text_box mbt_20" placeholder="请输入手机号" />
                        <input type="text" className="text_box text_yzm mbt_20" placeholder="验证码" /><button className="btn_yzm mbt_20">发送验证码</button>
                        <div className="mtt_10">
                         <button className="btn_login">登 录</button>
                        </div>
                    </div>

                </div>
                
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Login/Login.js